import React, { useRef, useMemo, useCallback } from 'react';
import styled from 'styled-components/macro';

import useFlavorStore from '../../../../../common/store/useFlavorStore';
import Container from '../../Container';
import { getVh } from '../../utils';
import useParallax from '../../useParallax';
import useAnimation from './useAnimation';

const Vegetable = styled.img`
  aspect-ratio: 20/37;
  width: 250rem;
  height: auto;
`;

const Rosemary = styled.img`
  aspect-ratio: 256/503;
  width: 90rem;
  height: auto;

  transform: rotate(45deg);
`;

const RedRhubarb = () => {
  const flavor = useFlavorStore(useCallback(state => state.flavor, []));

  const ref = {
    figure: {
      vegetable: useRef<HTMLElement>(null),
      rosemary: useRef<HTMLElement>(null)
    },
    img: {
      vegetable: useRef<HTMLImageElement>(null),
      rosemary: useRef<HTMLImageElement>(null)
    }
  }

  const top = {
    vegetable: useMemo(() => getVh("flavor", 0.4), []),
    rosemary: useMemo(() => getVh("flavor", 0.2), [])
  }

  useAnimation(flavor === "redrhubarb", [ref.figure.vegetable, ref.figure.rosemary]);

  useParallax(ref.img.vegetable, top.vegetable, 150);
  useParallax(ref.img.rosemary, top.rosemary, 100);

  return (
    <>
      <Container
        ref={ref.figure.vegetable}
        top={top.vegetable}
        style={{ left: "60vw" }}
      >
        <Vegetable
          ref={ref.img.vegetable}
          src="/static/images/fill/red_rhubarb.png"
        />
      </Container>

      <Container
        ref={ref.figure.rosemary}
        top={top.rosemary}
        style={{ right: "50rem" }}
      >
        <Rosemary
          ref={ref.img.rosemary}
          src="/static/images/fill/rosemary/2.png"
        />
      </Container>
    </>
  );


}

export default RedRhubarb;